import React from 'react';

const DarkThemeSwitcher = ({ theme, handleClick }) => {
  return (
    <div className='dark-theme-switcher nav-link d-flex align-items-center' onClick={() => handleClick()}>
      {theme.darkTheme ? (
        <i className='material-icons'>sunny</i>
      ) : (
          <i className='material-icons'>dark_mode</i>
      )}
    </div>
  );
};

export default DarkThemeSwitcher;